<nav class="navbar navbar-expand navbar-light bg-light event-create-edit-nav pl-2">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a routerLink="/events/scheduled/private-event/edit/{{ privateEvent ? privateEvent.id : '' }}/event-details"
         routerLinkActive="active"
         [class.disabled]="loadingEvent"
         class="nav-link" href="#">
        Event Details
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/events/scheduled/private-event/edit/{{ privateEvent ? privateEvent.id : '' }}/reservations"
         routerLinkActive="active"
         [class.disabled]="loadingEvent"
         class="nav-link" href="#">
        Reservations
      </a>
    </li>
    <li class="nav-item">
      <a routerLink="/events/scheduled/private-event/edit/{{ privateEvent ? privateEvent.id : '' }}/payment"
         routerLinkActive="active"
         [class.disabled]="loadingEvent"
         class="nav-link" href="#">
        Payment
      </a>
    </li>
  </ul>
</nav>
